import type { CategoriesResponse } from '@/types/Category.types';
import { apiCategories } from './categories';

export const fetchCategories = async (): Promise<
  CategoriesResponse | undefined
> => {
  const sessionKey = 'slayd_categories';
  if (!sessionStorage.getItem(sessionKey)) {
    try {
      const data = await apiCategories();
      sessionStorage.setItem(sessionKey, JSON.stringify(data));
      return data;
    } catch (error) {
      console.error('Error fetching categories:', error);
      return undefined;
    }
  } else {
    try {
      const cached = sessionStorage.getItem(sessionKey);
      if (cached) {
        return JSON.parse(cached) as CategoriesResponse;
      }
      return undefined;
    } catch (err) {
      console.error('error fteching categories from cache: ', err);
      return undefined;
    }
  }
};
